import { useMutation } from '@tanstack/react-query'

import { apiClient } from '../../lib/client.js'
import { writeQuoteToken } from '../public-estimate/quote-token.js'
import { estimateAuthHeaders } from './estimate-token.js'

/**
 * Récupère les jetons de portée `quote` des propositions de la demande, et les
 * range en session.
 *
 * Le jeton de la demande est le parent : il dérive ceux de SES propositions.
 * Une fois rangés, toutes les actions déjà servies par la page publique d'une
 * proposition — refuser, demander une modification, télécharger le PDF,
 * réserver — fonctionnent ici sans une ligne de plus.
 */
export const useIssueQuoteTokensMutation = () =>
  useMutation({
    mutationFn: async (estimateId: string) => {
      const response = await apiClient.client.post<{
        tokens: { responseId: string; token: string }[]
      }>(`/public/estimates/${estimateId}/quote-tokens`, undefined, {
        headers: estimateAuthHeaders(estimateId),
      })

      for (const { responseId, token } of response.data.tokens) {
        writeQuoteToken(responseId, token)
      }

      return response.data.tokens.map(({ responseId }) => responseId)
    },
    // Sans jetons, les boutons de la page sont là mais chaque geste répond 404 :
    // une coupure d'une seconde ne doit pas coûter au client toutes ses actions.
    // Au-delà, la page propose la reprise (cf. la page publique d'une demande).
    retry: 1,
    retryDelay: 800,
  })
